<template lang="pug">
    div.footer.is-size-7.has-background-blue-dark
        div.container.has-text-grey
            div.logo.has-text-centered.animated(id="footer-logo" data-animate="fadeInUp")
                img(src="../assets/logo-white.svg", alt="casa-relvas-logo")

            div.columns
                div.column
                    div.columns
                        div.column.is-narrow.has-margin.has-text-centered-mobile(v-for="link in $t('footer.links')")
                            router-link.has-text-grey(:to="link.url") {{ link.name }}
                div.column.is-gapless.is-narrow.has-text-centered-mobile
                    div.social
                        span.is-hidden-mobile |
                        a.has-text-grey(href="http://www.facebook.com/CasaRelvas", target="_blank")
                            i.fab.fa-facebook-f.fa-fw
                        a.has-text-grey(href="http://www.instagram.com/casarelvas", target="_blank")
                            i.fab.fa-instagram.fa-fw

            hr.has-background-grey-dark

            div.certs.columns.is-gapless.is-multiline.is-mobile
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/bureau.svg", alt="bureau-logo")
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/pme.svg", alt="pme-logo")
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/efw.svg", alt="efw-logo")
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/alentejo.svg", alt="alentejo-logo")
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/portugal.svg", alt="portugal")
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/ue.svg", alt="ue-logo")
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/wm.svg", alt="wm")

            //div.certs.columns.is-gapless.is-multiline.is-mobile
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/bureau.svg", alt="bureau-logo")
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/pme.svg", alt="pme-logo")
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/efw.svg", alt="efw-logo")
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/alentejo.svg", alt="alentejo-logo")
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/portugal.svg", alt="portugal")
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/ue.svg", alt="ue-logo")
                div.column.is-narrow
                    img.certs-logo(src="../assets/images/certs/wm.svg", alt="wm")

            hr.has-background-grey-dark

            div.columns
                div.column
                    p.is-size-14 Casa Relvas {{ new Date().getFullYear() }} | {{  $t('footer.rights') }}
                div.column.is-narrow
                    a.has-text-grey(
                        :href="'https://bo.herdadesaomiguel.com/assets/docs/' + $t('footer.doc_01.filename')",
                        target="_blank",
                        @mouseover="dochover = 1"
                        @mouseout="dochover = null")
                        img.is-inline-block.footer-link-icon(src="../assets/images/footer/doc_hover.svg" v-if="dochover === 1")
                        img.is-inline-block.footer-link-icon(src="../assets/images/footer/doc.svg" v-else)
                        | {{ $t('footer.doc_01.name') }}
                div.column.is-narrow
                    a.has-text-grey(
                        :href="'https://bo.herdadesaomiguel.com/assets/docs/' + $t('footer.doc_02.filename')",
                        target="_blank",
                        @mouseover="dochover = 2"
                        @mouseout="dochover = null")
                        img.is-inline-block.footer-link-icon(src="../assets/images/footer/doc_hover.svg", v-if="dochover === 2")
                        img.is-inline-block.footer-link-icon(src="../assets/images/footer/doc.svg", v-else)
                        | {{ $t('footer.doc_02.name') }}

                div.column.is-narrow
                    router-link.has-text-grey(:to="$t('footer.privacy.url')") {{ $t('footer.privacy.name') }}

</template>

<script>
export default {
    name: 'the-footer',
    data () {
        return {
            dochover: null
        }
    },
    created () {
        document.addEventListener('scroll', this.animate)
    },
    methods: {
        animate () {
            const elm = document.querySelector('#footer-logo')
            const bounding = elm.getBoundingClientRect()

            const visible = bounding.top >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)

            visible ? elm.classList.add(elm.dataset.animate) : elm.classList.add(elm.dataset.animate)
        }
    }
}
</script>

<style lang="stylus" scoped>

.footer
    padding-top 60px
    padding-bottom 60px
a
    font-size: 14px
    &:hover
        color white !important

.footer-link-icon
    width 11px
    margin-right 10px
    vertical-align middle

.margin-right
    margin-right 20px

.logo
    margin-bottom 2.5rem
    img
        width 8rem

.certs
    justify-content space-between
    &-logo
        height 54px
        @media screen and (max-width 1024px)
            height 25px

.social
    font-size 14px
    > *
        margin-right 0.5rem

.has-margin
    @media screen and (min-width 1025px) {
        margin-right 1.250rem
    }
</style>
